import React, { useEffect, useState } from 'react';
import { useStyles } from './Thumbnails.styles';
import { CloseIcon } from './Menu/CloseIcon.component';
import PagesThumbnails from '../PagesThumbnails/PagesThumbnails.component';
import { thumbNailPage } from '../PagesThumbnails/PagesThumbnails.types';
import { rotateAngleValue } from './Preview.types';

interface ThumbnailsProps {
  isOpen: boolean;
  isFullscreen: boolean;
  totalPages: number | undefined;
  currentPage: number | undefined;
  pagesUrls: string[];
  setCurrentPage: (page: number) => void;
  handleThumbnailsOpen: () => void;
  setRotateAngle: (angle: rotateAngleValue) => void;
  isAnnotationOpenAndDocked: boolean;
}

export const Thumbnails: React.FC<ThumbnailsProps> = (props) => {
  const classes = useStyles();
  const [pages, setPages] = useState<thumbNailPage[]>([]);

  useEffect(() => {
    setPages(
      props.pagesUrls.map((url: string, index: number) => {
        return {
          id: index,
          caption: index + 1,
          url,
        };
      }),
    );
  }, [props.pagesUrls]);

  return (
    <>
      {props.isOpen && props.pagesUrls && (
        <div className={classes.cardSidebar} style={{ left: props.isAnnotationOpenAndDocked ? '163px' : '40px' }}>
          <div className={classes.cardThumbnails}>
            <PagesThumbnails
              currentPageNo={props.currentPage}
              thumbnailWidth="200px"
              pages={pages}
              onClickPage={(pageNo: number) => {
                props.setCurrentPage(pageNo);
                props.setRotateAngle(0);
              }}
            />
          </div>
          <div className={classes.closeIcon} onClick={props.handleThumbnailsOpen}>
            <CloseIcon />
          </div>
        </div>
      )}
    </>
  );
};
